import { Button, Grid, Grid2, Stack } from "@mui/material";
import { Category, Subcategory } from "../../../../domain/model/Category";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomImageView } from "../../../component/CustomImageView";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { useTranslation } from "react-i18next";
import { CustomCardView } from "../../../component/CustomCardView";
import { COLOR_LIGHT_GRAY, COLOR_MAIN } from "../../../../data/colors/Colors";
import { calculateGamesLeftForSubcategory } from "../../../../core/utils/Utils";
import { LoadingView } from "../../../component/LoadingView";

export function ChooseCategoryDetailsView({
  category,
  onCategoryClicked,
  onSubcategoryClicked,
  onPopoverClose,
}: {
  category: Category;
  onCategoryClicked: (category: Category, closePopover: () => void) => void;
  onSubcategoryClicked: (category: Category, subcategory: Subcategory) => void;
  onPopoverClose: () => void;
}) {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  return (
    <Stack
      maxWidth={"100%"}
      p={1}
      spacing={2}
      minWidth={width < 700 ? "90vw" : "30vw"}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"space-between"}
      >
        <CustomTextView
          text={category.title}
          variant="h4"
          fontWeight="bold"
          props={{ width: "100%" }}
        />
        <CustomImageView
          src={category.imageUrl}
          width={150}
          height={150}
          props={{ borderRadius: 4, border: "solid 1px black" }}
        />
      </Stack>

      {category.numberOfQuestionsForEachSubcategory != null ? (
        <>
          <Grid2
            container
            maxWidth={width < 700 ? undefined : "30vw"}
            minWidth={"20vw"}
            spacing={1}
          >
            {category.subcategories?.map((subcategory) => {
              return (
                <Grid2 key={subcategory.title}>
                  <SubcategoryView
                    subcategory={subcategory}
                    category={category}
                    onSubcategoryClicked={(s) =>
                      onSubcategoryClicked(category, subcategory)
                    }
                  />
                </Grid2>
              );
            })}
          </Grid2>

          <CustomButtonView
            text={category.isSelected ? t("unselect") : t("select")}
            fontSize="h6"
            onClick={() => onCategoryClicked(category, onPopoverClose)}
            textColor={category.isSelected ? "red" : undefined}
            backgroundColor={
              category.subcategories.filter((s) => s.isSelected).length > 0
                ? COLOR_MAIN
                : COLOR_LIGHT_GRAY
            }
          />
        </>
      ) : (
        <LoadingView minHeight="20vh" />
      )}
    </Stack>
  );
}

function SubcategoryView({
  category,
  subcategory,
  onSubcategoryClicked,
}: {
  category: Category;
  subcategory: Subcategory;
  onSubcategoryClicked: (subcategory: string) => void;
}) {
  // const selectedSubcategoriesNumber = category.subcategories.filter(
  //   (s) => s.isSelected
  // ).length;

  // const gamesLeft =
  //   calculateGamesLeftForSubcategory(category, subcategory) *
  //   (subcategory.isSelected
  //     ? selectedSubcategoriesNumber == 0
  //       ? 1
  //       : selectedSubcategoriesNumber
  //     : 1);

  // const notAllowedToChoose = gamesLeft == 0;
  return (
    <CustomCardView
      background={subcategory.isSelected ? COLOR_MAIN : COLOR_LIGHT_GRAY}
      padding={1}
      children={
        <Button
          sx={{ p: 0 }}
          onClick={() => onSubcategoryClicked(subcategory.title)}
          // disabled={notAllowedToChoose}
        >
          <CustomTextView
            text={subcategory.title}
            textColor="white"
            props={{ textTransform: "none" }}
            fontWeight={subcategory.isSelected ? "bold" : "normal"}
          />
        </Button>
      }
    />
  );
}
